<template>
    <v-card>
        <slot>
            <v-card-title>
                {{ title }}
                <v-spacer></v-spacer>
                <v-select
                    v-model="type"
                    :items="expenseTypes"
                    label="Tip cheltuiala"
                    multiple
                    hide-details
                ></v-select>
                <v-text-field
                    v-model.lazy="search"
                    append-icon="mdi-magnify"
                    label="Cautare..."
                    single-line
                    hide-details
                ></v-text-field>
                <v-btn
                    color="primary"
                    dark
                    class="ml-2"
                    @click="addNewItem"
                >
                    Adaugare
                </v-btn>
            </v-card-title>
        </slot>
        <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="meta.pagination.total"
            :footer-props="footerOptions"
            class="elevation-1"
        >
            <template v-slot:no-data>
                <p class="my-2">Nu am gasit nici un rezultat.</p>
                <v-btn
                    class="my-2"
                    color="primary"
                    @click="reset"
                >
                    Eliminare filtre
                </v-btn>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                    v-if="canDelete(item)"
                    small
                    @click="deleteItem(item)"
                >
                    mdi-delete
                </v-icon>
            </template>
            <template v-slot:item.supplier_id="{ item }">
                {{ _.get(item.supplier, 'name', 'Nedefinit') }}
            </template>
            <template v-slot:item.document_date="{ item }">
                {{ new Date(item.document_date) | date }}
            </template>
            <template v-slot:item.vehicle_id="{ item }">
                <template v-if="item.object">
                    {{ _.get(item.object, 'brand', 'Marca necunoscuta') }}
                    {{ _.get(item.object, 'model', 'Model necunoscut') }}
                    ({{ _.get(item.object, 'vehicle_plate', 'Numar identificare necunoscut') || 'Numar identificare necunoscut' }})
                </template>
                <template v-else>
                    Necunoscut
                </template>
            </template>
            <template v-slot:item.type="{ item }">
                {{ _.get(item, 'items.0.name', 'Nedefinit') }}
            </template>
            <template v-slot:item.date_expire_start="{ item }">
                <template v-if="_.get(item, 'items.0.date_expire_start')">
                    {{ new Date(_.get(item, 'items.0.date_expire_start')) | date }}
                </template>
            </template>
            <template v-slot:item.date_expire_end="{ item }">
                <template v-if="_.get(item, 'items.0.date_expire_end')">
                    {{ new Date(_.get(item, 'items.0.date_expire_end')) | date }}
                </template>
            </template>
            <template v-slot:item.amount_with_vat="{ item }">
                {{ item.amount_with_vat | price }}
            </template>
            <template v-slot:item.remarks="{ item }">
                {{ item.remarks }}
            </template>
        </v-data-table>
        <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
                <v-card-title class="headline">Sunteti sigur ca doriti stergerea intrarii?</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="closeDelete">Anulare</v-btn>
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm">Confirmare</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
    import SmartTable from "Components/SmartTable";
    export default {
        extends: SmartTable,
        data: () => ({
            title: 'Impozite, RCA si ITP auto',
            dialog: false,
            dialogDelete: false,
            headers: [
                { text: 'Furnizor', value: 'supplier_id' },
                { text: 'Data', value: 'document_date' },
                { text: 'Vehicul', value: 'vehicle_id' },
                { text: 'Tip cheltuiala', value: 'type' },
                { text: 'Valabil de la', value: 'date_expire_start', sortable: false },
                { text: 'Valabil pana la', value: 'date_expire_end', sortable: false },
                { text: 'Valoare', value: 'amount_with_vat' },
                { text: 'Observatii', value: 'remarks' },
                { text: 'Actiuni', value: 'actions', sortable: false },
            ],
            items: [],
            editedIndex: -1,
            editedItem: {},
            defaultItem: {},
            options: {
                sortBy: ['document_date'],
                sortDesc: [true]
            },
            type: []
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Adaugare' : 'Modificare'
            },
            expenseTypes () {
                return [
                    'Impozit',
                    'RCA',
                    'ITP',
                    'CASCO',
                    'Vinieta',
                ]
            }
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
            type (val) {
                this.initialize()
            }
        },

        async created () {
            await this.initialize()
        },

        methods: {
            async initialize () {
                let query = this.$db.Expense
                    .orderBy(this.orderBy)
                    .where('expense', true)
                    .include('supplier', 'object', 'items')
                    .page(this.options.page)
                    .limit(this.options.itemsPerPage)
                    .params({
                        query: this.search,
                    })

                if (this.type.length > 0) {
                    query = query.where('type', this.type.join('|'))
                }

                let { data, meta } = await query.get()
                this.items = data
                this.meta = meta
            },


            async deleteItemConfirm () {
                let item = this.items[this.editedIndex]
                if(item instanceof this.$db.Expense) {
                    await item.delete()
                }
                this.dialogDelete = false
                await this.initialize()
            },

            addNewItem: function() {
                this.$router.push({ name: 'vehicle-expenses-create' })
            },

            editItem (item) {
                this.$router.push({ name: 'vehicle-expenses-edit', params: { id: item.id } })
            }
        },
    };
</script>
